function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "delivery/letterbox");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#666666",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#333333",
  offset: "100%"
})), /*#__PURE__*/React.createElement("path", {
  d: "M0,215 C0,333.742201 96.2598977,430 214.998648,430 L214.998648,430 C333.742807,430 430,333.742201 430,215 L430,215 C430,96.2577987 333.742807,0 214.998648,0 L214.998648,0 C96.2598977,0 0,96.2577987 0,215 L0,215 Z",
  id: "path-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,215 C0,333.742201 96.2598977,430 214.998648,430 L214.998648,430 C333.742807,430 430,333.742201 430,215 L430,215 C430,96.2577987 333.742807,0 214.998648,0 L214.998648,0 C96.2598977,0 0,96.2577987 0,215 L0,215 Z",
  id: "path-4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,215 C0,333.742201 96.2598977,430 214.998648,430 L214.998648,430 C333.742807,430 430,333.742201 430,215 L430,215 C430,96.2577987 333.742807,0 214.998648,0 L214.998648,0 C96.2598977,0 0,96.2577987 0,215 L0,215 Z",
  id: "path-6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,215 C0,333.742201 96.2598977,430 214.998648,430 L214.998648,430 C333.742807,430 430,333.742201 430,215 L430,215 C430,96.2577987 333.742807,0 214.998648,0 L214.998648,0 C96.2598977,0 0,96.2577987 0,215 L0,215 Z",
  id: "path-8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M214.998648,430 C333.742807,430 430,333.742201 430,215 C430,96.2577987 333.742807,0 214.998648,0 C96.2598977,0 0,96.2577987 0,215 C0,333.742201 96.2598977,430 214.998648,430 Z",
  id: "path-10"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "path-12",
  points: "0.484831458 63.891045 18.3179523 0.0778189052 99.584794 0.0778189052 117.415208 63.891045"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "path-14",
  points: "0.484831458 63.891045 18.3179523 0.0778189052 99.584794 0.0778189052 117.415208 63.891045"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "path-16",
  points: "0.484831458 63.891045 18.3179523 0.0778189052 99.584794 0.0778189052 117.415208 63.891045"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "path-18",
  points: "0.484831458 63.891045 18.3179523 0.0778189052 99.584794 0.0778189052 117.415208 63.891045"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "path-20",
  points: "0.484831458 63.891045 18.3179523 0.0778189052 99.584794 0.0778189052 117.415208 63.891045"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-22",
  points: "190.739977 16.8214429 0.525435103 16.8891651 9.14152854 0.527493972 182.110349 0.467898481"
}), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "49.9997275%",
  y1: "50.3711116%",
  x2: "49.9967074%",
  y2: "49.628737%",
  id: "linearGradient-24"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#000000",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#000000",
  offset: "100%"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "delivery/letterbox",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "llustration",
  transform: "translate(95.000000, 95.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M430,215 C430,333.742201 333.742201,430 215,430 C96.2605031,430 0,333.742201 0,215 C0,96.2577987 96.2605031,0 215,0 C333.742201,0 430,96.2577987 430,215",
  id: "Fill-1",
  fill: "#B8D5E1"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-3",
  fill: "url(#linearGradient-1)",
  points: "76.1771562 286.666667 354.825175 286.666667 354.825175 216.503497 76.1771562 216.503497"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-9",
  transform: "translate(49.114219, 196.456876)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M325.072946,0.655549819 L5.8607893,0.655549819 C2.874262,0.655549819 0.450413763,3.07107883 0.450413763,6.04735565 L0.450413763,105.795764 C0.450413763,108.77204 2.874262,111.187569 5.8607893,111.187569 L325.072946,111.187569 C328.062178,111.187569 330.483321,108.77204 330.483321,105.795764 L330.483321,6.04735565 C330.483321,3.07107883 328.062178,0.655549819 325.072946,0.655549819 L325.072946,0.655549819 Z M27.5022914,84.2285403 L303.431444,84.2285403 L303.431444,27.614579 L27.5022914,27.614579 L27.5022914,84.2285403 Z",
  id: "Fill-5",
  fill: "#F2F2F2"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-7",
  fill: "#B3B3B3",
  points: "285.992992 33.0775567 49.5649913 33.0775567 27.0524187 27.736973 302.981571 27.736973"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-25"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-12"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-3",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-2"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-11"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-15"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-5",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-4"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-14"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-13",
  fill: "#F2F2F2",
  opacity: 0.3,
  mask: "url(#mask-5)",
  points: "187.446172 159.559748 -137.295374 159.559748 -137.295374 127.106918 154.972017 127.106918"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-18"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-7",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-6"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-17"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-16",
  fill: "#000000",
  opacity: 0.1,
  mask: "url(#mask-7)",
  points: "187.446172 159.559748 187.446172 -164.968553 154.972017 -164.968553 154.972017 127.106918"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-21"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-9",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-8"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-20"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-19",
  fill: "#F2F2F2",
  opacity: 0.3,
  mask: "url(#mask-9)",
  points: "236.157404 159.559748 560.898949 159.559748 560.898949 127.106918 268.631558 127.106918"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-24"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-11",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-10"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-23"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-22",
  fill: "#000000",
  opacity: 0.1,
  mask: "url(#mask-11)",
  points: "236.157404 159.559748 236.157404 -164.968553 268.631558 -164.968553 268.631558 127.106918"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group-70",
  transform: "translate(71.165501, 232.540793)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-39",
  fill: "#EFDF9A",
  points: "287.286758 111.512176 0.0213845863 111.612405 0.0186776766 108.941444 287.286758 108.838506"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-41",
  fill: "#E0CE80",
  points: "230.097878 0.467627592 57.1317645 0.527223083 0.0186776766 108.939547 287.284051 108.839319"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-58",
  transform: "translate(47.987800, 21.671088)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-45"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-13",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-12"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-44"
}), /*#__PURE__*/React.createElement("path", {
  d: "M99.5850647,0.078631571 L25.8109489,0.0948848867 L0.485102149,63.8918577 L106.628444,63.8728955 L99.5850647,0.078631571 M30.8918183,50.3284658 C30.5994721,50.3284658 30.331488,50.298668 30.09328,50.2390726 C29.8550719,50.1794771 29.6520537,50.0927927 29.4869322,49.9871462 C29.3245176,49.8842085 29.2054136,49.7568909 29.1377409,49.6187377 C29.0673612,49.4805845 29.0511198,49.3288869 29.0971372,49.1690626 L37.1691418,20.3194273 C37.2043316,20.2056541 37.2855389,20.0945898 37.404643,19.994361 C37.523747,19.8941322 37.6834547,19.804739 37.8675245,19.7288902 C38.0515944,19.6557503 38.2600264,19.5934459 38.4874068,19.5528126 C38.7120803,19.5094704 38.9529953,19.4877993 39.1993241,19.4877993 L39.9247758,19.4877993 C40.1711046,19.4877993 40.398485,19.5094704 40.5960894,19.5528126 C40.7991077,19.5934459 40.9723499,19.6557503 41.1131092,19.7288902 C41.2538685,19.804739 41.3567311,19.8941322 41.4216969,19.994361 C41.4839558,20.0945898 41.5056111,20.2056541 41.4758351,20.3194273 L34.1509375,49.1690626 C34.1103339,49.3288869 34.0128852,49.4805845 33.8721259,49.6187377 C33.7286596,49.7568909 33.5445898,49.8842085 33.328037,49.9871462 C33.1114842,50.0927927 32.8651555,50.1794771 32.5971714,50.2390726 C32.3291874,50.298668 32.0449618,50.3284658 31.7526156,50.3284658 L30.8918183,50.3284658 M61.4230523,50.3284658 C61.1307061,50.3284658 60.8600151,50.2959592 60.6163933,50.2363637 C60.3700645,50.1767682 60.1562186,50.0873749 59.9775626,49.9817284 C59.8016135,49.8760818 59.6608542,49.7514731 59.5688192,49.6133199 C59.4794912,49.4751667 59.4334737,49.3234691 59.4470083,49.1690626 L61.7072779,31.0655779 C61.7235193,30.9355513 61.7911921,30.8109426 61.9021754,30.6971694 C62.0104517,30.586105 62.1593318,30.4831674 62.3406947,30.396483 C62.5220577,30.3125076 62.7331966,30.2447854 62.9659908,30.1960255 C63.1960782,30.1499744 63.4478208,30.1228855 63.710391,30.1228855 L64.4818603,30.1228855 C64.7444305,30.1228855 64.9907593,30.1499744 65.2127259,30.1960255 C65.4346925,30.2447854 65.6350038,30.3125076 65.7974183,30.396483 C65.9625398,30.4831674 66.0897646,30.586105 66.1763857,30.6971694 C66.2630068,30.8109426 66.3036105,30.9355513 66.2900759,31.0655779 L64.5305846,49.1690626 C64.5143432,49.3234691 64.4385497,49.4751667 64.3167388,49.6133199 C64.1949278,49.7514731 64.0243925,49.8760818 63.8213743,49.9817284 C63.6183561,50.0873749 63.380148,50.1767682 63.1202847,50.2363637 C62.8604214,50.2959592 62.5761959,50.3284658 62.2865565,50.3284658 L61.4230523,50.3284658 M46.1425473,50.3284658 C45.8583218,50.3284658 45.5930447,50.298668 45.3548366,50.2390726 C45.1166286,50.1794771 44.9054896,50.0927927 44.7376612,49.9871462 C44.5698328,49.8842085 44.4399012,49.7568909 44.3614008,49.6187377 C44.2829004,49.4805845 44.2531244,49.3288869 44.2856073,49.1690626 L47.4553985,33.3816753 C47.4824676,33.2489399 47.5636749,33.1216223 47.6881927,33.0051402 C47.8100037,32.8886581 47.9751252,32.7857204 48.1673158,32.6963272 C48.3595063,32.6096428 48.5841798,32.5392118 48.8250948,32.4904519 C49.0633028,32.4416919 49.3231662,32.4146031 49.5884433,32.4146031 L50.3707402,32.4146031 C50.6360174,32.4146031 50.8823461,32.4416919 51.1043127,32.4904519 C51.3262793,32.5392118 51.5211768,32.6096428 51.6808845,32.6963272 C51.8405922,32.7857204 51.9624031,32.8886581 52.0409035,33.0051402 C52.1166969,33.1216223 52.1491799,33.2489399 52.1248177,33.3816753 L49.3394076,49.1690626 C49.3123385,49.3288869 49.2257174,49.4805845 49.0957858,49.6187377 C48.9658541,49.7568909 48.789905,49.8842085 48.5814729,49.9871462 C48.3730409,50.0927927 48.1321259,50.1794771 47.8695557,50.2390726 C47.6069855,50.298668 47.3254668,50.3284658 47.0331206,50.3284658 L46.1425473,50.3284658 M76.7035574,50.3149214 C76.4112111,50.3149214 76.1323994,50.2824147 75.8833637,50.2228192 C75.6316211,50.1632237 75.4069476,50.0792483 75.2201709,49.9736017 C75.0333941,49.8679552 74.8845141,49.7433464 74.7816515,49.6051932 C74.6814958,49.4643312 74.6300646,49.3126336 74.6381853,49.1528093 L75.0875323,39.4577065 C75.095653,39.3114267 75.1579119,39.1759824 75.2634814,39.0513736 C75.3690509,38.9267649 75.5179309,38.8157005 75.6992939,38.7235984 C75.8833637,38.6287874 76.0972096,38.5529386 76.3381245,38.5014698 C76.5763326,38.4500009 76.8361959,38.4202032 77.1095938,38.4202032 L77.9189598,38.4202032 C78.1950646,38.4202032 78.4549279,38.4500009 78.690429,38.5014698 C78.9286371,38.5529386 79.142483,38.6287874 79.321139,38.7235984 C79.499795,38.8157005 79.6432612,38.9267649 79.74071,39.0513736 C79.8408656,39.1759824 79.8922969,39.3114267 79.88959,39.4577065 L79.6892787,49.1528093 C79.6865718,49.3126336 79.6243129,49.4643312 79.5160365,49.6051932 C79.4077601,49.7433464 79.2534663,49.8679552 79.0585688,49.9736017 C78.8690851,50.0792483 78.6389978,50.1632237 78.3872552,50.2228192 C78.1328057,50.2824147 77.8567009,50.3149214 77.5643546,50.3149214 L76.7035574,50.3149214",
  id: "Fill-43",
  fill: "#FFFFFF",
  mask: "url(#mask-13)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-48"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-15",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-14"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-47"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.9247758,19.4867158 L39.1993241,19.4867158 C38.9529953,19.4867158 38.7120803,19.5110958 38.4874068,19.5517291 C38.2600264,19.5950712 38.0515944,19.6546667 37.8675245,19.7305155 C37.6834547,19.8063643 37.523747,19.8957576 37.404643,19.9932775 C37.2855389,20.0962151 37.2043316,20.2045706 37.1691418,20.3210527 L29.0971372,49.1679791 C29.0511198,49.3278033 29.0673612,49.4795009 29.1377409,49.620363 C29.2054136,49.7585162 29.3245176,49.8831249 29.4869322,49.9887715 C29.6520537,50.094418 29.8550719,50.1811024 30.09328,50.237989 C30.331488,50.2975845 30.5994721,50.3300911 30.8918183,50.3300911 L31.7526156,50.3300911 C32.0449618,50.3300911 32.3291874,50.2975845 32.5971714,50.237989 C32.8651555,50.1811024 33.1114842,50.094418 33.328037,49.9887715 C33.5445898,49.8831249 33.7286596,49.7585162 33.8721259,49.620363 C34.0128852,49.4795009 34.1103339,49.3278033 34.1509375,49.1679791 L41.4758351,20.3210527 C41.5056111,20.2045706 41.4839558,20.0962151 41.4216969,19.9932775 C41.3567311,19.8957576 41.2538685,19.8063643 41.1131092,19.7305155 C40.9723499,19.6546667 40.7991077,19.5950712 40.5987964,19.5517291 C40.398485,19.5110958 40.1711046,19.4867158 39.9247758,19.4867158",
  id: "Fill-46",
  fill: "#CCCCCC",
  mask: "url(#mask-15)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-51"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-17",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-16"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-50"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.3701988,32.4148739 L49.5879019,32.4148739 C49.3226248,32.4148739 49.0654684,32.4419628 48.8245534,32.4907228 C48.5836385,32.5394827 48.358965,32.6099137 48.1667744,32.6965981 C47.9745838,32.7859913 47.8094623,32.888929 47.6876514,33.0054111 C47.5631335,33.1218932 47.4846331,33.2492108 47.4548571,33.3819462 L44.2850659,49.1693335 C44.252583,49.3291578 44.282359,49.4808554 44.3608594,49.6190086 C44.4393598,49.7571617 44.5692914,49.8844794 44.7371198,49.987417 C44.9049482,50.0930636 45.1160872,50.179748 45.3542952,50.2393434 C45.5925033,50.2989389 45.8577804,50.3287367 46.1420059,50.3287367 L47.0325792,50.3287367 C47.3249255,50.3287367 47.6064441,50.2989389 47.8690143,50.2393434 C48.1315845,50.179748 48.3724995,50.0930636 48.5809315,49.987417 C48.7920705,49.8844794 48.9653127,49.7571617 49.0952444,49.6190086 C49.227883,49.4808554 49.3117972,49.3291578 49.3415732,49.1693335 L52.1242763,33.3819462 C52.1486385,33.2492108 52.1188625,33.1218932 52.0403621,33.0054111 C51.9618617,32.888929 51.8400508,32.7859913 51.6803431,32.6965981 C51.5206354,32.6099137 51.3257379,32.5394827 51.1037713,32.4907228 C50.8818048,32.4419628 50.635476,32.4148739 50.3701988,32.4148739",
  id: "Fill-49",
  fill: "#CCCCCC",
  mask: "url(#mask-17)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-54"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-19",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-18"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-53"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.4824016,30.1226147 L63.7082255,30.1226147 C63.4483621,30.1226147 63.1966195,30.1497035 62.9638253,30.1957546 C62.733738,30.2445145 62.522599,30.3122367 62.3412361,30.398921 C62.1598731,30.4828965 62.0109931,30.5858342 61.9000098,30.6968985 C61.7917334,30.8106717 61.7213538,30.9352804 61.7078192,31.0680159 L59.4475497,49.1687917 C59.4340151,49.3231982 59.4773257,49.4748958 59.5693606,49.613049 C59.6613955,49.7512022 59.8021548,49.8758109 59.978104,49.9841664 C60.1540531,50.0898129 60.3706059,50.1764973 60.6142277,50.2360928 C60.8605565,50.2956883 61.1312475,50.3281949 61.4235937,50.3281949 L62.284391,50.3281949 C62.5767372,50.3281949 62.8582558,50.2956883 63.1208261,50.2360928 C63.3806894,50.1764973 63.6188975,50.0898129 63.8219157,49.9841664 C64.0249339,49.8758109 64.1954692,49.7512022 64.3172801,49.613049 C64.4390911,49.4748958 64.5148846,49.3231982 64.531126,49.1687917 L66.2906173,31.0680159 C66.3041518,30.9352804 66.2635482,30.8106717 66.1769271,30.6968985 C66.090306,30.5858342 65.9603743,30.4828965 65.7979597,30.398921 C65.6328382,30.3122367 65.4352338,30.2445145 65.2132672,30.1957546 C64.9885937,30.1497035 64.7449719,30.1226147 64.4824016,30.1226147",
  id: "Fill-52",
  fill: "#CCCCCC",
  mask: "url(#mask-19)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-57"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-21",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-20"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.9192305,38.4210159 L77.1098645,38.4210159 C76.8364666,38.4210159 76.5738964,38.4481047 76.3383952,38.5022824 C76.0974803,38.5537513 75.8836344,38.6296001 75.6995646,38.7217022 C75.5182016,38.8165132 75.3693216,38.9275775 75.2637521,39.0521863 C75.1554757,39.176795 75.0959237,39.3122393 75.087803,39.4558103 L74.638456,49.153622 C74.6303352,49.3134462 74.6817665,49.4651438 74.7819222,49.603297 C74.8820778,49.7441591 75.0336648,49.8687678 75.2177346,49.9744144 C75.4072183,50.0773521 75.6318918,50.1640364 75.8836344,50.2236319 C76.1326701,50.2805185 76.4114818,50.315734 76.703828,50.315734 L77.5646253,50.315734 C77.8569716,50.315734 78.1330763,50.2805185 78.3875259,50.2236319 C78.6392684,50.1640364 78.8693558,50.0773521 79.0588394,49.9744144 C79.2537369,49.8687678 79.4080308,49.7441591 79.5163072,49.603297 C79.6245836,49.4651438 79.6868425,49.3134462 79.6895494,49.153622 L79.8898607,39.4558103 C79.8925676,39.3122393 79.8384294,39.176795 79.7409807,39.0521863 C79.6435319,38.9275775 79.4973588,38.8165132 79.3214097,38.7217022 C79.1427536,38.6296001 78.9289078,38.5537513 78.6906997,38.5022824 C78.4551986,38.4481047 78.1953353,38.4210159 77.9192305,38.4210159",
  id: "Fill-55",
  fill: "#CCCCCC",
  mask: "url(#mask-21)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group-61",
  transform: "translate(47.987800, 0.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-23",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-22"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-60"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-59",
  fill: "url(#linearGradient-24)",
  opacity: 0.148460751,
  mask: "url(#mask-23)",
  points: "190.739977 16.8214429 182.110349 0.467898481 9.14152854 0.527493972 0.525435103 16.8891651"
})), /*#__PURE__*/React.createElement("path", {
  d: "M0,111.803111 L8.12072897,168.689715 C8.12072897,170.179603 9.33883832,171.398601 10.8276386,171.398601 L276.104785,171.398601 C277.593585,171.398601 278.811695,170.179603 278.811695,168.689715 L286.932424,111.803111 L0,111.803111 Z",
  id: "Fill-62",
  fill: "#C6B25D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.580714,140.350976 C147.580714,147.142153 139.422089,152.646609 129.360506,152.646609 C119.298922,152.646609 111.143004,147.142153 111.143004,140.350976 C111.143004,133.562508 119.298922,128.055343 129.360506,128.055343 C139.422089,128.055343 147.580714,133.562508 147.580714,140.350976",
  id: "Fill-64",
  fill: "#009552"
}), /*#__PURE__*/React.createElement("path", {
  d: "M175.457553,140.350976 C175.457553,147.142153 167.298927,152.646609 157.237344,152.646609 C147.175761,152.646609 139.019842,147.142153 139.019842,140.350976 C139.019842,133.562508 147.175761,128.055343 157.237344,128.055343 C167.298927,128.055343 175.457553,133.562508 175.457553,140.350976",
  id: "Fill-66",
  fill: "#009552"
}), /*#__PURE__*/React.createElement("path", {
  d: "M139.018489,140.350976 C139.018489,143.365966 140.6291,146.126321 143.30082,148.266341 C145.969833,146.126321 147.580444,143.365966 147.580444,140.350976 C147.580444,137.335986 145.969833,134.575631 143.30082,132.435611 C140.6291,134.575631 139.018489,137.335986 139.018489,140.350976",
  id: "Fill-68",
  fill: "#00693B"
}))));

var SvgLetterbox = function SvgLetterbox(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "620px",
    height: "620px",
    viewBox: "0 0 620 620",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLetterbox, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/letterbox.36ec3389.svg";
export { ForwardRef as ReactComponent };